import { useTheme } from "@mui/system";

export default function PromotionIcon() {
  const theme = useTheme();
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_125_1393)">
        <path 
          fillRule="evenodd" 
          clipRule="evenodd" 
          d="M20 10L10 0H0V10L10 20L20 10ZM5.625 7.5C6.66054 7.5 7.5 6.66054 7.5 5.625C7.5 4.58946 6.66054 3.75 5.625 3.75C4.58946 3.75 3.75 4.58946 3.75 5.625C3.75 6.66054 4.58946 7.5 5.625 7.5Z" 
          fill={theme.palette.rgd.primary}
        />
      </g>
      <defs>
      <clipPath id="clip0_125_1393">
      <rect width="20" height="20" fill="white"/>
      </clipPath>
      </defs>
    </svg>
  )
}